// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.holiday-allowance-modal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.holiday-allowance-modal__content {
  z-index: 1;
  position: relative;
  width: 600px;
  background: #ffffff;
  padding: 50px;
  border-radius: 16px;
}
.holiday-allowance-modal__action {
  position: absolute;
  top: 20px;
  right: 20px;
}
.holiday-allowance-modal__action__close {
  padding: 20px;
  cursor: pointer;
}

.holiday-allowance__header {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 41px;
  color: #353d47;
}
.holiday-allowance__body {
  height: 500px;
  padding-top: 30px;
  position: relative;
}
.holiday-allowance__body__weeks {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  border-bottom: 1px solid #f2f2f2;
}
.holiday-allowance__body__weeks-last {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  border-bottom: 1px solid #292d31;
}
.holiday-allowance__body__week {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
}
.holiday-allowance__body__date {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}
.holiday-allowance__body__bottom {
  display: flex;
}
.holiday-allowance__body__bottom__sum {
  position: absolute;
  bottom: 0;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #333333;
}
.holiday-allowance__body__bottom__value {
  right: 0;
  position: absolute;
  bottom: 0;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #075453;
}
.holiday-allowance__body__won {
  padding-top: 10px;
  margin-left: auto;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #505054;
}`, "",{"version":3,"sources":["webpack://./src/screens/payroll-register/holiday-allowance-modal/holiday-allowance-modal.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AACJ;AACI;EACI,UAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AACR;AAEI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AAAR;AACQ;EACI,aAAA;EACA,eAAA;AACZ;;AAKI;EACI,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFR;AAKI;EACI,aAAA;EACA,iBAAA;EACA,kBAAA;AAHR;AAKQ;EACI,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,gCAAA;AAHZ;AAMQ;EACI,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,gCAAA;AAJZ;AAOQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AALZ;AAQQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AANZ;AASQ;EACI,aAAA;AAPZ;AASY;EACI,kBAAA;EACA,SAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAPhB;AAUY;EACI,QAAA;EACA,kBAAA;EACA,SAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAThB;AAaQ;EACI,iBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAXZ","sourcesContent":[".holiday-allowance-modal {\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2;\n\n    &__content {\n        z-index: 1;\n        position: relative;\n        width: 600px;\n        background: #ffffff;\n        padding: 50px;\n        border-radius: 16px;\n    }\n\n    &__action {\n        position: absolute;\n        top: 20px;\n        right: 20px;\n        &__close {\n            padding: 20px;\n            cursor: pointer;\n        }\n    }\n}\n\n.holiday-allowance {\n    &__header {\n        font-family: 'Noto Sans KR';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 28px;\n        line-height: 41px;\n        color: #353d47;\n    }\n\n    &__body {\n        height: 500px;\n        padding-top: 30px;\n        position: relative;\n\n        &__weeks {\n            padding-top: 20px;\n            padding-bottom: 20px;\n            display: flex;\n            border-bottom: 1px solid #f2f2f2;\n        }\n\n        &__weeks-last {\n            padding-top: 20px;\n            padding-bottom: 20px;\n            display: flex;\n            border-bottom: 1px solid #292d31;\n        }\n\n        &__week {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 22px;\n            color: #333333;\n        }\n\n        &__date {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n            color: #999999;\n        }\n\n        &__bottom {\n            display: flex;\n\n            &__sum {\n                position: absolute;\n                bottom: 0;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 24px;\n                color: #333333;\n            }\n\n            &__value {\n                right: 0;\n                position: absolute;\n                bottom: 0;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 24px;\n                color: #075453;\n            }\n        }\n\n        &__won {\n            padding-top: 10px;\n            margin-left: auto;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 18px;\n            line-height: 24px;\n            color: #505054;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
